$(document).ready(function(){
  // Open external link in new tab
  function externalLinks() {
    for(var c = document.getElementsByTagName("a"), a = 0;a < c.length;a++) {
      var b = c[a];
      b.getAttribute("href") && b.hostname !== location.hostname && (b.target = "_blank")
    }
  };
  externalLinks();
  
  function close_drawer(){
    $('html').removeClass('js-drawer-open lock-scroll');
    $('#NavDrawer1').removeClass('drawer--is-open');
  }
  $(document).on('click', '.cstm_announce_btn', function(e){
    e.preventDefault();
    $('html').addClass('js-drawer-open lock-scroll');
    $('#NavDrawer1').addClass('drawer--is-open');
     
  });

  $(document).on('click', '.drawer__close-button', function(e){
    e.preventDefault();
    close_drawer();
  });
  
  // sidebar blog mobile toggle
  $('.menu_btn').on('click', function(e){
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).next().slideToggle('300');
  });
  
  //popup js starts
      // $(".points_description .descript_popup").children().css("margin","0");
      $('.lists_Content .points_div').on('click', function(){
        var point_id= $(this).attr("point-id");
        $(".points_description .descript_popup").each(function(){
             var descript_id= $(this).attr("descript-id");
          if(point_id == descript_id){
            $(this).fadeIn();
            $(".points_description").addClass("points_description_show");
            $("body").css("overflow", "hidden");
          }else{
            $(this).hide();
          }
        });
      });
      $('.colse_popup , .overlay').on('click', function(){
          $(".points_description .descript_popup").fadeOut();
            $(".points_description").removeClass("points_description_show");
            $("body").css("overflow", "auto");
      });
  //popup js ends

  $(document).on('click', function(){
    setTimeout(function(){
      $(".cart-link__bubble").load(location.href+" #item_count");
    }, 1000);
  });


  

     $(document).on('click', '#ItgCreateDraftOrder', function(e) {
        e.preventDefault();
         $(this).css('pointer-events', 'none');
        var ajaxData = new FormData;
        var wholesale_product = '';
        $(document).find("form#CartPageForm .cart__item").each(function(){
           var data_id = $(this).attr('data-itgid');
           var data_qty = $(this).attr('data-itgqty');
           wholesale_product +=data_id+':'+data_qty+',';
        });
        var lastCommaRemoved = wholesale_product.replace(/,*$/, ''); 
        var wholesale_customer_id = $(document).find('.ItgCustomerDetails').attr('data-emailid');
        ajaxData.append('wholesale_data', lastCommaRemoved);
        ajaxData.append('customer_id', wholesale_customer_id);

       $(document).find('#ItgCreateDraftOrder').text('Creating draft order..');
       
         $.ajax({
            url: 'https://dev.shopifyexperthelp.com/app/project_app/mac_ride/draft_order.php',
            type: 'POST',
            data: ajaxData,
            dataType: false,
            cache: false,
            contentType: false,
            processData: false,
            complete: function() {},
            success: function(res) {
              $(document).find('#ItgCreateDraftOrder').text('Create Draft Order');
              $(document).find('#draft_order_msg').text(res);
              $(document).find('#draft_order_msg').show();
              $(this).css('pointer-events', 'auto');
              
              setTimeout(function() {
                  $(document).find('#draft_order_msg').hide();
              }, 10000);

              setTimeout(function() {
                window.location.href = '/cart/clear'
              }, 2000);
            },error: function(xhr, textStatus, errorThrown) {
              $(this).css('pointer-events', 'auto');
            }
        });
    
      
    });

  
});